import React from 'react'
import { SVGProps } from 'react'

const HeartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.57124 11.3303L4.57125 11.3303C6.00327 12.5654 7.42335 13.4772 7.99906 13.8302C8.57189 13.4765 9.98186 12.5652 11.4078 11.331C12.4839 10.3995 13.3189 9.49782 13.9075 8.6556L13.9075 8.65559C14.67 7.56474 14.9948 6.60689 14.9999 5.79617C15.0066 4.74477 14.5993 3.74302 13.9079 3.04725L13.9079 3.04723C13.2791 2.41448 12.4785 2.08105 11.6529 2.08105C10.5416 2.08105 9.48482 2.70436 8.86017 3.75774L8.00002 5.20824L7.13989 3.75773C6.51525 2.70434 5.45848 2.08105 4.3472 2.08105C3.47446 2.08105 2.64363 2.44852 2.00321 3.15211C1.37044 3.84731 1.00652 4.78461 1.00006 5.80284M8.23566 14.8554C8.16281 14.8977 8.08138 14.9189 8 14.9189C7.91906 14.9189 7.83816 14.898 7.76566 14.8562C7.68691 14.8107 5.81594 13.7244 3.91814 12.0876C2.79332 11.1175 1.89545 10.1553 1.24952 9.22782C0.413642 8.02763 -0.00670048 6.8732 8.07525e-05 5.79655C0.00801824 4.54374 0.456736 3.36555 1.26367 2.47899C2.08423 1.57749 3.17929 1.08105 4.3472 1.08105C5.49339 1.08105 6.56433 1.57272 7.35681 2.39946C7.59921 2.65234 7.81556 2.93658 8.00003 3.24768C8.18451 2.93658 8.40086 2.65235 8.64326 2.39947C9.43574 1.57273 10.5067 1.08105 11.6529 1.08105C12.7562 1.08105 13.809 1.52899 14.6172 2.34236C15.5042 3.23496 16.0082 4.49614 15.9999 5.80248C15.9931 6.87726 15.5649 8.02995 14.7272 9.22848C14.0792 10.1555 13.1826 11.1173 12.0622 12.0871C10.1713 13.7237 8.31381 14.81 8.23566 14.8554ZM2.07011 8.65631L2.07012 8.65633C2.65597 9.49754 3.49122 10.3989 4.57124 11.3303M2.07011 8.65631C1.31084 7.56612 0.994982 6.61076 1.00006 5.80288Z"
      />
    </g>
  </svg>
)
export default HeartIcon
